export default __webpack_public_path__ + "static/media/aside.5bcd63eb.jpg";